import classNames from "classnames";
import { t } from "@/i18n-js/instance";
import { reactQueryPut } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import { useCustomizeSpaceDrawer } from "@circle-react/components/Drawers/CustomizeSpaceDrawer";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { usePunditUserContext } from "@circle-react/contexts";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";

export const BannerActions = ({
  isAdmin,
  coverUrl,
  allowClose,
  spaceId,
  refetchSpace,
}: any) => {
  const { show: showSpaceDrawer } = useCustomizeSpaceDrawer();
  const { currentCommunityMember } = usePunditUserContext();

  const openCustomizeModal = () => {
    void showSpaceDrawer({
      spaceId: spaceId,
      initialSection: t("customize_space.customize"),
      scrollToId: "space-welcome-banner",
    });
  };

  const closeBanner = () => {
    reactQueryPut(
      internalApi.spaceMembers.update({
        spaceId: spaceId,
        memberId: currentCommunityMember?.id,
      }),
      { space_member: { display_space_welcome_banner: false } },
    )
      .then(() => refetchSpace())
      .catch(error => {
        console.error(error);
      });
  };

  if (isAdmin) {
    return (
      <span className="absolute right-3 top-3 z-10">
        <BlockInViewOnlyMode>
          <Dropdown
            buttonClassName="welcome_banner_dropdown"
            direction="bottom-end"
            menuButtonEl="div"
            button={
              <Dropdown.MenuButton className="!py-0">
                <IconButton
                  name="20-menu-dots-horizontal"
                  iconClassName="!text-default group-hover:!text-dark !w-5 !h-5"
                  className={classNames("group", {
                    "bg-tertiary": coverUrl,
                  })}
                  variant="secondary"
                  iconSize={20}
                  buttonSize={28}
                  data-testid="welcome_banner_button"
                  ariaLabel={t("home_page.welcome_banner_actions")}
                />
              </Dropdown.MenuButton>
            }
          >
            <Dropdown.ItemLink onClick={openCustomizeModal}>
              <div>{t("home_page.edit_banner")}</div>
            </Dropdown.ItemLink>
            {allowClose && (
              <Dropdown.ItemLink hasDanger onClick={closeBanner}>
                <div>{t("home_page.hide_banner")}</div>
              </Dropdown.ItemLink>
            )}
          </Dropdown>
        </BlockInViewOnlyMode>
      </span>
    );
  }
  if (allowClose) {
    return (
      <button
        type="button"
        className="absolute right-3 top-3 z-10"
        onClick={closeBanner}
      >
        <IconButton
          name="16-close"
          className="bg-primary rounded-full"
          iconSize={16}
          ariaLabel={t("home_page.welcome_banner_actions")}
        />
      </button>
    );
  }
  return null;
};
